import "./EllipsisText.css";


interface EllipsisTextProps {
  text: string | number;
  length?: number;
  underline?: boolean | null;
  showTooltip?: boolean; // Add this new prop
}

const EllipsisText: React.FC<EllipsisTextProps> = ({
  text,
  length = 26,
  underline,
  showTooltip = true,
}) => {
  const classNames = `ellipsis-text ${underline ? "underline" : ""}`;
  // Convert text to string to handle both numbers and strings
  const textStr = String(text);

  if (textStr.length <= length) {
    return (
      <span className={classNames} title={showTooltip ? textStr : undefined}>
        {text}
      </span>
    );
  }

  return (
    <span className={classNames} title={showTooltip ? textStr : undefined}>
      {textStr.substring(0, length)}...
    </span>
  );
};

export default EllipsisText;